export const getDivisoesSetores = (state) => state.divisoesSetores.lista
export const getTotalDivisoesSetores = (state) => state.divisoesSetores.total
export const getIsCarregandoListaDivisoesSetores =
  (state) => state.divisoesSetores.isCarregandoLista
